import PropTypes from 'prop-types';
import React from 'react';
import ManagementTeamDialog from './ManagementTeamDialog';

const ManagementTeamAction = ({
  managementTeamMember,
  toggleManagementTeamDialog,
}) => (
  <ManagementTeamDialog
    managementTeamMember={managementTeamMember}
    toggleManagementTeamDialog={toggleManagementTeamDialog}
  />
);

ManagementTeamAction.propTypes = {
  managementTeamMember: PropTypes.object.isRequired,
  toggleManagementTeamDialog: PropTypes.func.isRequired,
};

export default ManagementTeamAction;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ManagementTeam/ManagementTeamAction.js